__turbopack_context__.v({
  "card": "oqNYrG_card",
  "cardContent": "oqNYrG_cardContent",
  "cardSubtitle": "oqNYrG_cardSubtitle",
  "cardTitle": "oqNYrG_cardTitle",
  "grid": "oqNYrG_grid",
  "image": "oqNYrG_image",
  "imageWrap": "oqNYrG_imageWrap",
  "insetBorder": "oqNYrG_insetBorder",
  "section": "oqNYrG_section" + " " + __turbopack_context__.i(46473)["sectionPadding"],
  "title": "oqNYrG_title",
});
